import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import process_Rep_data from '../../serviceFunctions/MonthlyAnalysis/rep_sales';
import { useLandingDataContext } from '../../context/LandingDataProvider';
import useResizeObserver from './useResizeObserver';

function repSortByTotalAmount(arr) {
    return arr.sort((a, b) => b.sales - a.sales);
  }

function convertDataFormat(arr){
    return arr.map((item)=>({
        id:item._id,
        value:item.sales.toFixed(2),
        label:item.repname
        
    }));
}


export default function RepPieChart({includeCEO}) {
    const {apiData,dataFetch} = useLandingDataContext();
  // console.log("apidata",apiData)
    const chartData = includeCEO
    ? apiData[0]
    : apiData[0].filter((rep) => rep.repDetails.repname !== 'REP-CEO');


    React.useEffect(()=>{
        if(apiData==null){
            dataFetch({month:new Date().getMonth(),year:new Date().getFullYear()})
        }
      },[])
    React.useEffect(()=>{
        if(chartData!=null){
            const processedRepData = process_Rep_data(chartData);
    const sortedRepData =  repSortByTotalAmount(processedRepData);
    const dataForPieChart = convertDataFormat(sortedRepData.slice(0,5));
    setRepData(dataForPieChart)
        }
        
    },[apiData,includeCEO])

    const [containerRef, { width }] = useResizeObserver();
    const isMobile = width ? width < 640 : false;


    const[repData,setRepData] = React.useState([])
    // console.log("repdata",repData)
    const chartWidth = Math.min(500, width || 300);
    const chartHeight = chartWidth;
    const radius = Math.min(chartWidth, chartHeight) / 2.5;
  
    return (
      <div ref={containerRef} className="w-full h-full flex justify-center">
        <div className="rounded-lg overflow-hidden font-bold h-full opacity-95 flex justify-center">
          <PieChart
            series={[
              {
                data: repData,
                innerRadius: radius / 2.5,
                outerRadius: radius,
                paddingAngle: 5,
                cornerRadius: 5,
                startAngle: -180,
                endAngle: 180,
                cx: chartWidth / 2,
                cy: chartHeight / 2,
                highlightScope: { faded: 'global', highlighted: 'item' },
                faded: { innerRadius: radius / 2.5, additionalRadius: -20, color: 'gray' },
              },
            ]}
            colors={['#00BDFF', '#00B3CF', '#00CEC7', "#49E6B7", '#3befb9']}
            width={chartWidth}
            height={chartHeight}
            margin={{
              top: 20,
              bottom: 20,
              left: 5,
              right: 20
            }}
            slotProps={{
              legend: {
                hidden: isMobile,
                direction: 'row',
                position: {
                  vertical: 'bottom',
                  horizontal: 'middle'
                },
                padding: 20,
                itemMarkWidth: 12,
                itemMarkHeight: 12,
                markGap: 5,
                itemGap: 10,
                labelStyle: {
                  fontSize: 12,
                },
              },
            }}
          />
        </div>
      </div>
    );
  }
  